import React from "react"
import classes from "./single.module.css"
import { Link } from "gatsby"

const single = props => {
  return (
    <div className={classes.Single}>
      <Link to={props.link}>
        <img src={props.image} alt={props.title} />
        <h3>{props.title}</h3>
      </Link>
    </div>
  )
}

export default single
